var map = {
	"./back.png": "P9/e",
	"./go.png": "+sPs",
	"./jia.png": "943w",
	"./jiaBlue.png": "AMkS",
	"./logo-zgys.png": "F6iy",
	"./logo-zh.png": "G6rd",
	"./logo.png": "7Otq",
	"./me-selected.png": "OUVK",
	"./me.png": "MiQ5",
	"./nav1.png": "VnM4",
	"./nav1Active.png": "UrNF",
	"./nav2.png": "SNEu",
	"./nav2Active.png": "rIqF",
	"./nav3.png": "/7uH",
	"./nav3Active.png": "0hJm",
	"./radio.png": "Qhv2",
	"./rili.png": "5IqO",
	"./seach.png": "YFNm",
	"./touxiang.png": "4pSz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 2